// --Function 1. Xử lí header overlay lên block banner đầu tiên tại index ( main page ) --
function setHeight() {
  const pageContent = document.querySelector("main");
  if (pageContent?.id === "MainContent") {
    let firstMainProductBanner = document.querySelector(".main-product-banner");
    if (firstMainProductBanner) {
      let headerWrapperHeight =
        document.querySelector("sticky-header")?.getBoundingClientRect()
          ?.height ?? 0;

      let announcementBarHeight =
        document
          .querySelector(".announcement-bar-section")
          ?.getBoundingClientRect()?.height ?? 0;

      // Calculate the height
      var windowHeight = window.innerHeight;

      const bannerHeight =
        windowHeight - (announcementBarHeight + headerWrapperHeight);

      // Set the height of the element
      firstMainProductBanner.style.height = bannerHeight + "px";
    }
  }
}

// --End Function 1--
// function onscroll() {
//    let sectionHeader = document.querySelector(".section-header");
//   let scrollY = window.scrollY;
//     if(scrollY > 65 && scrollY <= 250 ){

//         sectionHeader.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');

//   }else{

//         sectionHeader.classList.add('scrolled-past-header', 'shopify-section-header-sticky');

//   }
//   // console.log(scrollY)
// }
//When DOM loaded
document.addEventListener("DOMContentLoaded", function () {
  //************************IntersectionObserver************************************
  if ("IntersectionObserver" in window) {
    var imgObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyImg = entry.target;
            lazyImg.setAttribute("src", lazyImg.getAttribute("lazy-src"));
            imgObserver.unobserve(lazyImg);
          }
        });
      },
      { rootMargin: "50px", threshold: 0 }
    );

    var lazyBgObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyBg = entry.target;
            lazyBg.style.backgroundImage =
              "url(" + lazyBg.getAttribute("lazy-src") + ")";
            lazyBgObserver.unobserve(lazyBg);
          }
        });
      },
      { rootMargin: "50px", threshold: 0 }
    );
  } else {
    // Fallback for browsers that do not support IntersectionObserver
    lazyBgElements.forEach(function (lazyBg) {
      lazyBg.style.backgroundImage =
        "url(" + lazyBg.getAttribute("lazy-src") + ")";
    });
  }
  //**************************************************************************

  var lazyBgElements = document.querySelectorAll(".lazy-bg");
  if (lazyBgElements) {
    lazyBgElements.forEach(function (lazyBg) {
      lazyBgObserver.observe(lazyBg);
    });
  }
  var lazyImgElements = document.querySelectorAll(".lazy-img");
  if (lazyImgElements) {
    lazyImgElements.forEach(function (lazyImg) {
      imgObserver.observe(lazyImg);
    });
  }
  if (window.scrollY > 65) {
    let sectionHeader = document.querySelector(".section-header");
    if (sectionHeader?.classList.contains("scrolled-past-header") === false) {
      sectionHeader.classList.add("scrolled-past-header");
    }
  }

  //Scroll Text
  // Lấy danh sách các phần tử .promo-content-block
  var promoBlocks = document.querySelectorAll(".promo-content-block");

  // Thiết lập hàm di chuyển
  function movePromoBlocks() {
    var position = document.querySelector(".marquee").offsetWidth; // Vị trí ban đầu của phần tử đầu tiên (bên phải)
    var speed = 1.5; // Tốc độ di chuyển
    var containerWidth = document.querySelector(".marquee").offsetWidth;
    var totalWidth = 0; // Tổng chiều dài của tất cả các phần tử block

    // Tính toán tổng chiều dài của tất cả các phần tử block
    promoBlocks.forEach(function (block) {
      totalWidth += block.offsetWidth;
    });

    var frame = function () {
      position -= speed;
      // Di chuyển tất cả các phần tử block
      promoBlocks.forEach(function (block) {
        block.style.transform = "translateX(" + position + "px)";
      });
      // Kiểm tra nếu phần tử block cuối cùng khuất màn hình góc trái
      if (position <= -totalWidth) {
        // Đặt lại vị trí của phần tử block đầu tiên để bắt đầu từ vị trí ngoài cùng bên phải
        position = containerWidth; // Đặt lại vị trí ban đầu
      }
      requestAnimationFrame(frame);
    };
    frame();
  }
  movePromoBlocks();
  // Bắt đầu di chuyển
  //End Scroll
});

// Call window events
window.addEventListener("load", setHeight);
window.addEventListener("resize", setHeight);
// window.addEventListener("scroll", onscroll);
//--------------------
